import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SvgIconModule } from '../svg-icon/svg-icon.module';
import { SelectAccountComponent } from './select-account.component';

@NgModule({
    imports: [
        CommonModule,
        SvgIconModule,
    ],
    exports: [ SelectAccountComponent ],
    declarations: [ SelectAccountComponent ],
})
export class SelectAccountModule {}
